import { css } from 'emotion';

import { colors, fonts } from '@cobliteam/base-components/src/styles';

export const banner = css`
  display: flex;
  align-items: center;
  padding: 20px 21.5px;
  box-sizing: border-box;
  color: ${colors.gray.dark};
  background-color: #fffaf2;
  border-radius: 5px;
  height: 60px;
  margin: -10px 20px 20px 20px;

  > span {
    font-weight: ${fonts.weight.medium};
    line-height: 18px;
  }
`;

export const warningIcon = css`
  color: ${colors.warning.default};
  font-size: ${fonts.size.large} !important;
  margin-right: 12px;
`;
